if (!customElements.get('quickbuy-widget')) {
  customElements.define(
    'quickbuy-widget',
    class QuickbuyWidget extends HTMLElement {
      constructor() {
        super();
      }
    
      connectedCallback() {   
        const sizeSelect = this.querySelectorAll('[data-option-select]');
        const mainSelect = this.querySelector('[data-main-select]');
        const disabledSelect = this.querySelector('[data-disabled-select]');
        const pic = this.querySelector('img');
      
        const updateOptionsAvailability = (targetSelect) => {
          const selectedValues = [...sizeSelect].map(select => select.value);
      
          sizeSelect.forEach((select, index) => {
            if (select === targetSelect) return;
      
            const otherSelections = selectedValues.filter((_, i) => i !== index);
      
            [...select.options].forEach(option => {
              const testCombination = [
                ...otherSelections.slice(0, index),
                option.value,
                ...otherSelections.slice(index)
              ].join('-');
      
              const isDisabled = [...disabledSelect?.options].some(
                opt => opt.innerText.trim() === testCombination
              );
      
              option.disabled = isDisabled;
            });
          });
        };
      
        sizeSelect.forEach(select => {
          select.addEventListener('mousedown', () => updateOptionsAvailability(select));
        });
      
        this.addEventListener('change', (e) => {
          updateOptionsAvailability(e.target)
          let options = [];
          sizeSelect.forEach(select => options.push(select.value));
          options = options.join('-');
      
          [...mainSelect.options].forEach(option => {
            option.innerText.trim() === options
              ? option.setAttribute('selected', 'selected')
              : option.removeAttribute('selected');
          });
      
          pic.removeAttribute('srcset');
          pic.setAttribute('src', mainSelect.querySelector('option:checked')?.getAttribute('data-image'));
        });
      
        if (this.closest('gift-with-purchase')) {
          const gwp = this.closest('gift-with-purchase');
          const config = gwp?.configuration;
          const giftId = this.querySelector(`[name="properties[_free_gift]"]`);
          if (giftId) giftId.setAttribute('value', gwp.id);
          if (!config || !giftId) return;
          if (config?.gifts.length > 1) return;
          this.querySelector('[data-message]').innerHTML = config.addedMessage;
          const selectionError = this.querySelector('[data-selection-needed]');
          if (selectionError) selectionError.innerHTML = config.selection_required_message;
        }
      }
    }
  );
}